import { useLang } from "../context/LanguageContext";
import { useAIAssistant } from "../context/AIAssistantContext";

export const Consultation = () => {
  const { t } = useLang();
  const { openAssistant } = useAIAssistant();

  return (
    <section
      id="consultation"
      data-testid="consultation-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden fk-glass p-10 sm:p-14 lg:p-20 text-center fk-glow">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-[#FF5A00]/20 blur-[90px]" />
            <div className="absolute -bottom-20 -right-10 w-80 h-80 rounded-full bg-[#FF5A00]/10 blur-[100px]" />
          </div>
          <div className="fk-noise" />

          <div className="relative">
            <div className="eyebrow inline-block">{t.consultation.eyebrow}</div>
            <h2
              data-testid="consultation-title"
              className="mt-5 font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-[1.05] tracking-tight"
            >
              {t.consultation.title}
            </h2>
            <p className="mt-6 max-w-2xl mx-auto text-base sm:text-lg text-zinc-400 leading-relaxed">
              {t.consultation.subtitle}
            </p>

            <div className="mt-10 flex flex-wrap justify-center gap-3">
              <button
                data-testid="cons-cta-primary"
                onClick={openAssistant}
                className="fk-btn fk-btn-primary"
              >
                <i className="fa-solid fa-wand-magic-sparkles" />
                {t.consultation.ctaPrimary}
              </button>
              <button
                data-testid="cons-cta-secondary"
                onClick={openAssistant}
                className="fk-btn fk-btn-secondary"
              >
                <i className="fa-solid fa-bolt" />
                {t.consultation.ctaSecondary}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
